function generateAndroidDeviceId(): string {
  const hexChars = "0123456789abcdef"
  let result = ""
  for (let i = 0; i < 16; i++) {
    result += hexChars.charAt(Math.floor(Math.random() * hexChars.length))
  }
  return result
}

let cached: string | null = null

export const generateRandomDeviceID = (): string => {
  if (cached) {
    return cached
  }

  const randomDeviceId = localStorage.getItem("be:tracking:id")

  cached = randomDeviceId || cached

  if (randomDeviceId) {
    return randomDeviceId
  }

  const newDeviceId = generateAndroidDeviceId()
  localStorage.setItem("be:tracking:id", newDeviceId)

  return newDeviceId
}
